import { render, staticRenderFns } from "./FedexUkraineReportEdit.vue?vue&type=template&id=4f72bd32&scoped=true"
import script from "./FedexUkraineReportEdit.vue?vue&type=script&lang=js"
export * from "./FedexUkraineReportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72bd32",
  null
  
)

export default component.exports